import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { hasAnyPermission, } from '@tymia/main-api';
import { useState, } from 'react';
import { useForm, } from 'react-hook-form';
import { api, } from '../api/Api.js';
import { Button, } from '../components/Button.js';
import { LanguageSwitcher, } from '../components/LanguageSwitcher.js';
import { Textbox, } from '../components/Textbox.js';
import { useTranslation, } from '../useTranslation.js';
import { ajvResolver, } from '../utils/ajvResolver.js';
import { logo, } from './search/logo.js';
export function Login() {
    const [isLoading, setIsLoading] = useState(false);
    const [token, setToken] = useState(null);
    const tRoot = useTranslation();
    const t = tRoot.login;
    const { handleSubmit, register, setValue, setError, formState: { errors, }, } = useForm({
        defaultValues: {
            email: '',
            password: '',
            tan: '',
        },
        shouldUnregister: false,
        resolver: ajvResolver(api.auth.login.validateRequest, {
            locale: tRoot.locale,
        }),
    });
    const tanMode = token !== null;
    async function onSubmit({ tan, ...data }) {
        try {
            setIsLoading(true);
            const result = await api.auth.login.request({
                ...data,
                ...token
                    ? {
                        token,
                        tan,
                    }
                    : {},
            });
            if (result.status === 'tan required') {
                setToken(result.token);
                setValue('tan', '', {
                    shouldDirty: false,
                    shouldTouch: false,
                    shouldValidate: false,
                });
                return;
            }
            if (result.status === 'success') {
                if (hasAnyPermission(result.user.permissions, 'customer.edit.all')) {
                    window.location.href = '/user/list';
                    return;
                }
                if (hasAnyPermission(result.user.permissions, 'appointment.see.specialist-own', 'appointment.see.customer')) {
                    window.location.href = '/appointment/list';
                    return;
                }
                window.location.href = '/';
                return;
            }
            if (result.status === 'error') {
                switch (result.error) {
                    case 'need verification': {
                        setError('email', {
                            type: 'manual',
                            message: t.needVerification,
                        });
                        return;
                    }
                    case 'invalid credentials': {
                        setError('email', {
                            type: 'manual',
                            message: t.invalidCredentials,
                        });
                        setError('password', {
                            type: 'manual',
                            message: t.invalidCredentials,
                        });
                        return;
                    }
                    case 'invalid tan': {
                        setError('tan', {
                            type: 'manual',
                            message: t.invalidTan,
                        });
                        return;
                    }
                    case 'account locked': {
                        setError('email', {
                            type: 'manual',
                            message: t.accountLocked,
                        });
                        setError('tan', {
                            type: 'manual',
                            message: t.accountLocked,
                        });
                        return;
                    }
                }
            }
        }
        finally {
            setIsLoading(false);
        }
    }
    return (_jsxs("div", { className: "\n\t\t\th-screen\n\t\t\tflex\n\t\t\titems-start\n\t\t\tjustify-center\n\t\t\tbg-background-root\n\t\t", children: [_jsx("title", { children: "Tymia Login" }), _jsxs("div", { className: "\n\t\t\t\tmt-[10%]\n\t\t\t\tp-8\n\t\t\t\tmax-w-xl\n\t\t\t\tw-full\n\t\t\t\tborder\n\t\t\t\trounded-lg\n\t\t\t\tshadow-md\n\t\t\t\tbg-background-main\n\t\t\t", children: [_jsx(LanguageSwitcher, { className: "absolute top-4 right-4" }), _jsx("div", { className: "flex justify-center", children: _jsx("a", { href: "/", className: "inline-block", children: _jsx("img", { src: logo, alt: "Tymia Logo", className: "h-20 my-7" }) }) }), _jsxs("form", { autoComplete: "on", noValidate: true, onSubmit: handleSubmit(onSubmit), children: [!tanMode && (_jsx(Textbox, { ...register('email'), label: tRoot.user.EMail, position: "external", inputMode: "email", autoComplete: "username", type: "email", reserveErrorSpace: 1, error: errors.email?.message, alwaysFloat: true })), !tanMode && (_jsx(Textbox, { ...register('password'), label: tRoot.user.Password, position: "external", autoComplete: "current-password", type: "password", error: errors.password?.message, reserveErrorSpace: 1, alwaysFloat: true })), tanMode && (_jsx(Textbox, { ...register('tan'), label: t.tanRequired, position: "external", inputMode: "numeric", autoComplete: "one-time-code", autoFocus: true, error: errors.tan?.message, reserveErrorSpace: 1, alwaysFloat: true })), _jsx(Button, { position: "external", className: "text-center", size: "lg", type: "submit", disabled: isLoading, children: t.submit }), _jsx("a", { href: "/password/reset", className: "block text-center mt-6", children: tRoot.forgotPassword.link })] })] })] }));
}
//# sourceMappingURL=Login.js.map